import BaseClient, { type ExtendedAxiosRequestConfig } from '../BaseClient';
import type { QueryParams } from '~/services/api';
import type { GroupsClientInterface } from './groupsClient.types';

export default class OrgUnitGroupsClient extends BaseClient implements GroupsClientInterface {
    constructor(private teamId: number, private orgUnitId: number) {
        super();
    }

    getGroups(params?: QueryParams, config?: ExtendedAxiosRequestConfig) {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/groups`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    countGroups() {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/groups/count`;
        return this.makeCoreApiRequest(url, 'get');
    }
}
